import React from "react"
import { adjustPlan } from "../../../../api/plans"
import Button from "../../../../_components/Button"
import Modal from "../../../../_components/Modal"

export default props => {
    const [loading, setLoading] = React.useState(false)
    const [show, setShow] = React.useState(false)
    const [message, setMessage] = React.useState("")
    const [title, setTitle] = React.useState("")

    async function tryAdjustPlan() {
        setLoading(true)
        adjustPlan().then(result => {
            if (result.updated) {
                setTitle("Assinatura atualizada!")
            } else {
                setTitle("Não foi possível atualizar!")
            }
            setMessage(result.message)
            setLoading(false)
            setShow(true)
        }).catch(() => {
            setLoading(false)
        })
    }
    function onHide() {
        setShow(false)
        window.location.reload()
    }
    return <div>
        <Button
            as="text"
            title="Ajustar Assinatura"
            text
            disabled={loading}
            loading={loading}
            onClick={tryAdjustPlan}>
            Recarregar os Dados do Plano
        </Button>
        <Modal
            onHide={onHide}
            title={title}
            show={show}>
            <p className="lead">
                {message}
            </p>
        </Modal>
    </div>
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Plans/AdjustBranchPlan/index.jsx